import CloseIcon from "@mui/icons-material/Close";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Button, DialogActions, Paper } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import StaticTableComponent from "../Master Data Import Export/StaticTableComponent";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const ValidatePopUpForStockHolder = ({
  handleCloses,
  open,
  validateDataList,
  onImportValidatedData,
  //   columnTag,
  validationTableTitle,
}) => {
  const [searchValue, setSearchValue] = React.useState("");

  const handleClose = () => {
    handleCloses();
  };

  const onSearchBox = (searchValue) => {
    setSearchValue(searchValue);
  };

  const getFilteredTableData = (searchData) => {
    if (!searchValue?.trim()) return searchData;

    const searchTerm = searchValue.trim().toLowerCase();

    return searchData.filter((row) => {
      const values = Object.values(row).map((value) => {
        if (value && typeof value === "object" && !Array.isArray(value)) {
          return Object.values(value);
        }
        return value;
      });

      return values.some((value) =>
        value?.toString().toLowerCase().includes(searchTerm)
      );
    });
  };

  // const getHeaders = () => {
  //   return [
  //     { label: "Sr. No", key: "srNo", align: "center" },
  //     {
  //       label: "Stock Holder",
  //       key: "stockStakeHolderTypeName",
  //       align: "left",
  //     },
  //     { label: "Region ", key: "regionName", align: "left" },
  //     { label: "State ", key: "stateNames", align: "left" },
  //     { label: "Zone ", key: "zoneNames", align: "left" },
  //     { label: "District ", key: "districtNames", align: "left" },
  //     {
  //       label: "Area ",
  //       key: "areaNames",
  //       align: "left",
  //     },
  //     {
  //       label: "Pincode",
  //       key: "pincode",
  //       align: "center",
  //     },
  //     { label: "Order To", key: "orderTo", align: "left" },
  //     { label: "Owner Name", key: "ownerName", align: "left" },
  //     { label: "Firm Name", key: "firmName", align: "left" },
  //     {
  //       label: "Contact Person Name",
  //       key: "contactPersonName",
  //       align: "left",
  //     },
  //     {
  //       label: "Contact Person No",
  //       key: "contactPersonNo",
  //       align: "center",
  //     },
  //     { label: "Address", key: "address", align: "left" },
  //     { label: "Email Id", key: "emailId", align: "left" },
  //     { label: "Bill Name", key: "billName", align: "left" },
  //     { label: "Credit Limit", key: "creditLimit", align: "center" },
  //     { label: "Payment Term", key: "paymentTerm", align: "left" },
  //     { label: "Gst Type", key: "gstType", align: "left" },
  //     { label: "Gst No", key: "gstNo", align: "center" },
  //     { label: "Pan No", key: "panNo", align: "center" },
  //     { label: "Brand Name", key: "brandName", align: "left" },
  //     { label: "Sh Code", key: "shCode", align: "center" },
  //     {
  //       label: "Error Message",
  //       key: "errorMessage",
  //       align: "left",
  //     },
  //   ];
  // };
  const getHeaders = () => {
    return [
      { label: "Sr. No", key: "srNo", align: "center", width: "100px" },
      {
        label: "Stock Holder",
        key: "stockStakeHolderTypeName",
        align: "left",
        width: "100px",
      },
      { label: "Region ", key: "regionName", align: "left", width: "100px" },
      { label: "State ", key: "stateNames", align: "left", width: "100px" },
      { label: "Zone ", key: "zoneNames", align: "left", width: "100px" },
      {
        label: "District ",
        key: "districtNames",
        align: "left",
        width: "100px",
      },
      {
        label: "Area ",
        key: "areaNames",
        align: "left",
        width: "150px",
      },
      {
        label: "Pincode",
        key: "pincode",
        align: "center",
        width: "100px",
      },
      { label: "Order To", key: "orderTo", align: "left", width: "100px" },
      { label: "Owner Name", key: "ownerName", align: "left", width: "150px" },
      { label: "Firm Name", key: "firmName", align: "left", width: "150px" },
      {
        label: "Contact Person Name",
        key: "contactPersonName",
        align: "left",
        width: "150px",
      },
      {
        label: "Contact Person No",
        key: "contactPersonNo",
        align: "center",
        width: "150px",
      },
      { label: "Address", key: "address", align: "left", width: "250px" },
      { label: "Email Id", key: "emailId", align: "left", width: "220px" },
      { label: "Bill Name", key: "billName", align: "left", width: "120px" },
      {
        label: "Credit Limit",
        key: "creditLimit",
        align: "center",
        width: "100px",
      },
      {
        label: "Payment Term",
        key: "paymentTerm",
        align: "left",
        width: "100px",
      },
      { label: "Gst Type", key: "gstType", align: "left", width: "100px" },
      { label: "Gst No", key: "gstNo", align: "center", width: "150px" },
      { label: "Pan No", key: "panNo", align: "center", width: "150px" },
      { label: "Brand Name", key: "brandName", align: "left", width: "100px" },
      { label: "Sh Code", key: "shCode", align: "center", width: "100px" },
      {
        label: "Error Message",
        key: "errorMessage",
        align: "center",
        width: "200px",
      },
    ];
  };

  const getTableData = () => {
    return getFilteredTableData(validateDataList).map(
      (validateDataListObj, indexRow) => {
        return {
          srNo: indexRow + 1,
          stockStakeHolderTypeName:
            validateDataListObj.stockStakeHolderType !== null &&
            validateDataListObj.stockStakeHolderType.name !== null
              ? validateDataListObj.stockStakeHolderType.name
              : "",
          regionName:
            validateDataListObj.region !== null &&
            validateDataListObj.region.name !== null
              ? validateDataListObj.region.name
              : "",
          stateNames:
            validateDataListObj.stateNames !== null
              ? validateDataListObj.stateNames
              : "",
          zoneNames:
            validateDataListObj.zoneNames !== null
              ? validateDataListObj.zoneNames
              : "",
          districtNames:
            validateDataListObj.districtNames !== null
              ? validateDataListObj.districtNames
              : "",
          areaNames:
            validateDataListObj.areaNames !== null
              ? validateDataListObj.areaNames
              : "",
          pincode:
            validateDataListObj.pincode !== null
              ? validateDataListObj.pincode
              : "",
          orderTo:
            validateDataListObj.orderTo !== null
              ? validateDataListObj.orderTo
              : "",
          ownerName:
            validateDataListObj.ownerName !== null
              ? validateDataListObj.ownerName
              : "",
          firmName:
            validateDataListObj.firmName !== null
              ? validateDataListObj.firmName
              : "",
          contactPersonName:
            validateDataListObj.contactPersonName !== null
              ? validateDataListObj.contactPersonName
              : "",
          contactPersonNo:
            validateDataListObj.contactPersonNo !== null
              ? validateDataListObj.contactPersonNo
              : "",
          address:
            validateDataListObj.address !== null
              ? validateDataListObj.address
              : "",
          emailId:
            validateDataListObj.emailId !== null
              ? validateDataListObj.emailId
              : "",
          billName:
            validateDataListObj.billName !== null
              ? validateDataListObj.billName
              : "",
          creditLimit:
            validateDataListObj.creditLimit !== null
              ? validateDataListObj.creditLimit
              : "",
          paymentTerm:
            validateDataListObj.paymentTerm !== null &&
            validateDataListObj.paymentTerm.paymentName !== null
              ? validateDataListObj.paymentTerm.paymentName
              : "",
          gstType:
            validateDataListObj.gtype !== null ? validateDataListObj.gtype : "",
          gstNo:
            validateDataListObj.gstNo !== null
              ? validateDataListObj.gstNo
              : "-",
          panNo:
            validateDataListObj.panNo !== null ? validateDataListObj.panNo : "",
          brandName:
            validateDataListObj.brand !== null &&
            validateDataListObj.brand.name !== null
              ? validateDataListObj.brand.name
              : "",
          shCode:
            validateDataListObj.shCode !== null
              ? validateDataListObj.shCode
              : "",
          errorMessage:
            validateDataListObj.flag == 0
              ? "-"
              : validateDataListObj.errorMessage || "",
          errorFlag: validateDataListObj.flag,
        };
      }
    );
  };

  return (
    <>
      <Paper sx={{ p: 3, pt: 2, borderRadius: 2 }} elevation={0}>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
          maxWidth="lg"
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            backgroundColor="#F0F0F0"
            fontFamily="'Montserrat', sans-serif"
            fontSize="23px"
            color="black"
          >
            {validationTableTitle}
          </BootstrapDialogTitle>

          <DialogContent dividers>
            <LandingScreenHeader
              screenTitle={""}
              showSearchBox={true}
              showTable={true}
              showFilter={false}
              showPdfDownload={false}
              showExcelDownload={false}
              onSearch={onSearchBox}
            />

            <StaticTableComponent
              title=""
              headers={getHeaders()}
              data={getTableData()}
              flag={1}
            />
          </DialogContent>

          <br />
          <DialogActions sx={{ justifyContent: "flex-end", padding: 2 }}>
            <Button
              size="medium"
              type="submit"
              variant="contained"
              name="Import Validated Only"
              color="primary"
              startIcon={<FileUploadIcon />}
              sx={{
                fontWeight: 600,
                padding: "5px 15px",
                border: "none",
                borderRadius: "6px",
                textTransform: "none",
                opacity: 0.6,
                color: "white",
                transition: "opacity 0.3s, transform 0.2s",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  backgroundColor: "#57B9FF",
                  borderColor: "#1976d2",
                  color: "white",
                  opacity: 1,
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 10px rgba(0, 0, 0, 0.2)",
                },
              }}
              onClick={onImportValidatedData}
            >
              Import Validated Only
            </Button>
          </DialogActions>
        </BootstrapDialog>
      </Paper>
    </>
  );
};

const mapStateToProps = (state) => ({
  beatList: state.beat,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ValidatePopUpForStockHolder);
